import React, { useEffect } from 'react';

const BringThemHomeNowEN = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://bringthemhomenow.net/1.1.0/hostages-ticker.js';
    script.setAttribute(
      'integrity',
      'sha384-DHuakkmS4DXvIW79Ttuqjvl95NepBRwfVGx6bmqBJVVwqsosq8hROrydHItKdsne'
    );
    script.setAttribute('crossorigin', 'anonymous');

    // Append the script to the head of the document
    document.head.appendChild(script);

    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return <div id="bthn" lang="en"></div>;
};

export default BringThemHomeNowEN;
